import { colors } from "../../theme/Colors";

export const DataGridHeaderStyle = {
  marginTop: "1rem",
  height: "70vh",
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: `${colors.mj_navbar}`,
    color: "white",
  },
  "& .MuiDataGrid-columnHeaderCheckbox": {
    backgroundColor: `${colors.mj_navbar}`,
  },
  "& .MuiSvgIcon-fontSizeSmall": {
    color: "white",
  },
};
